(function () {
  var container = document.querySelector('.blogcontent');
  if (!container) return;

  var maxWidth = 1150;
  var articleContent = container.closest('.article-content');
  if (articleContent) {
    var maxWidthStyle = getComputedStyle(articleContent).maxWidth;
    if (maxWidthStyle && maxWidthStyle !== 'none') {
      maxWidth = parseInt(maxWidthStyle, 10) || maxWidth;
    }
  }

  container.querySelectorAll('img').forEach(function (img) {
    var widthAttr = img.getAttribute('width');
    var heightAttr = img.getAttribute('height');
    if (widthAttr && heightAttr) {
      img.style.aspectRatio = widthAttr + ' / ' + heightAttr;
    }

    var src = img.getAttribute('src');
    if (!src || src.indexOf('data:') === 0 || src.indexOf('width=') !== -1) return;
    if (src.indexOf('cdn.shopify.com') === -1 && src.indexOf('/cdn/shop/') === -1) return;

    try {
      var widths = [400, 600, 800, 1000, maxWidth].filter(function (value, index, list) {
        return list.indexOf(value) === index && value <= maxWidth;
      });

      img.srcset = widths
        .map(function (width) {
          var sized = new URL(src, window.location.origin);
          sized.searchParams.set('width', String(width));
          return sized.toString() + ' ' + width + 'w';
        })
        .join(', ');

      img.sizes = '(max-width: 699px) 100vw, ' + maxWidth + 'px';
    } catch (error) {
      /* ignore malformed URLs */
    }
  });
})();
